/**
 * Created by desheng.zhao on 2018/12/6.
 */
function b2g(byte) {
  if(typeof byte == "number" || Number(byte)){
    return (Number(byte) / Math.pow(1024, 3)).toFixed(2);
  }else{
    console.warn("未知(流量)类型不可以转换");
    return byte;
  }
}

export default b2g;


// WEBPACK FOOTER //
// ./src/filters/BtoG.js